import React, { Fragment } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { getTypeTextSubstrings } from '../../utils/transactionTypeFormatting';
import { EmailText } from '../information/EmailText';

const RejectionContactInstructionBodyForBuyer = ({ itemText, rejectionContactDetails }) => {
  if (!rejectionContactDetails || !rejectionContactDetails.role) {
    return (
      <Fragment>
        In order to process your refund, the <span>{itemText}</span> must safely be transferred back
        to the seller.
      </Fragment>
    );
  }
  const hasContactDetails = rejectionContactDetails.name || rejectionContactDetails.email || rejectionContactDetails.phone;
  return (
    <Fragment>
      <p style={{ marginBottom: hasContactDetails ? '1em' : '0' }}>
        Your next step is to contact the {rejectionContactDetails.role} to explain your concerns and
        agree to a resolution. Include photos or documentation related to your rejection.
      </p>
      {
        rejectionContactDetails.name &&
        <div>Name: {rejectionContactDetails.name}</div>
      }
      {
        rejectionContactDetails.email &&
        <div>Email: <EmailText email={rejectionContactDetails.email} /></div>
      }
      {
        rejectionContactDetails.phone &&
        <div>Phone: {rejectionContactDetails.phone}</div>
      }
    </Fragment>
  );
};

const RejectionContactBannerBodyForBuyer = ({ itemText, rejectionContactDetails }) => {
  if (!rejectionContactDetails || !rejectionContactDetails.role) {
    return (
      <Fragment>
        In order to process your refund, the <span>{itemText}</span> must safely be transferred back
        to the seller.
      </Fragment>
    );
  }

  return (
    <Fragment>
      Contact the {rejectionContactDetails.role} to explain your concerns and agree to a resolution.
    </Fragment>
  );
};

export const itemRejectionBannerText = (role, itemText, rejectionContactDetails) => {
  let title;
  let body;
  let instructions;

  if (role === 'buyer') {
    title = `You have rejected the ${itemText}`;
    body = <RejectionContactBannerBodyForBuyer itemText={itemText} rejectionContactDetails={rejectionContactDetails} />;
    instructions =
      <RejectionContactInstructionBodyForBuyer
        itemText={itemText}
        rejectionContactDetails={rejectionContactDetails}
      />;
  } else {
    title = `The buyer has rejected the ${itemText}`;
    body = (
      <div>
        {rejectionContactDetails && (
          <Fragment>
            To agree to a resolution we have instructed the buyer to contact{' '}
            {rejectionContactDetails.role === role ? (
              <Fragment>you</Fragment>
            ) : (
              <Fragment>the {rejectionContactDetails.role}</Fragment>
            )}{'.'}
          </Fragment>
        )}
        {!rejectionContactDetails && (
          <Fragment>
            In order to process the buyer’s refund we have instructed them to safely return the{' '}
            {itemText} to{' '}
            {role === 'seller' ? <Fragment>you.</Fragment> : <Fragment>the seller.</Fragment>}
          </Fragment>
        )}
      </div>
    );
    instructions = (
      <div>
        {rejectionContactDetails && (
          <Fragment>
            The buyer has rejected the {itemText}, and has been informed to contact{' '}
            {rejectionContactDetails.role === role ? (
              <Fragment>you</Fragment>
            ) : (
              <Fragment>the {rejectionContactDetails.role}</Fragment>
            )}{' '}
            to agree to a resolution.
          </Fragment>
        )}
        {!rejectionContactDetails && (
          <Fragment>
            In order to process the buyer’s refund we have instructed them to safely return
            the {itemText} to{' '}
            {role === 'seller' ? <Fragment>you.</Fragment> : <Fragment>the seller.</Fragment>}
          </Fragment>
        )}
      </div>
    );
  }

  return { title, body, instructions };
};

const ItemRejectionBanner = ({ role, transactionTypeCode, multipleItems, transactionDetails }) => {
  const { itemText } = getTypeTextSubstrings(transactionTypeCode, multipleItems);
  const { title, body } = itemRejectionBannerText(role, itemText, (transactionDetails || {}).rejectionContactDetails);

  return (
    <Alert
      variant="outlined"
      severity="error"
      data-testid="item-rejection-banner"
      sx={{ bgcolor: 'background.paper' }}
    >
      <AlertTitle> {title} </AlertTitle>
      {body}
    </Alert>
  );
};

export default ItemRejectionBanner;
